import React, { Component } from 'react'
import { Container, Header } from '../../elements'
import './../../marketing/listMotorcycle/listBikeMarketing.css'
import './../blog.css'
class BlogMenu extends Component {
  render() {
    const { isMobile } = this.props

    return (
      <div className="blog-menu-wrap">
        <Container className="large mt-6">
          <nav className="level">
            <div className="level-left">
              <div className="level-item">
                <div className={isMobile ? 'has-text-centered' : null}>
                  <a href="/">
                    <img
                      style={{ maxWidth: '250px', height: 'auto' }}
                      className="twisted-road-blog-header-logo mb-2"
                      src="https://res.cloudinary.com/twisted-road/image/upload/c_scale,q_auto,h_54/q_auto,f_auto/v1574196392/seomarketing/twistedroadlogo.png"
                      alt="The Twisted Road Blog"
                    />
                    <Header renderas="h1" className="is-size-6">
                      The Twisted Road Blog
                    </Header>
                  </a>
                </div>
              </div>
            </div>
            {!isMobile && (
              <div className="level-right">
                <p className="level-item has-text-weight-bold">
                  <a href="/blog" className="has-text-dark">
                    All Posts
                  </a>
                </p>
                <p className="level-item has-text-weight-bold">
                  <a href="/blog/category/features" className="has-text-dark">
                    Features
                  </a>
                </p>
                <p className="level-item has-text-weight-bold">
                  <a href="/blog/category/bikes-gear" className="has-text-dark">
                    Bikes & Gear
                  </a>
                </p>
                <p className="level-item has-text-weight-bold">
                  <a href="/blog/category/community" className="has-text-dark">
                    Community
                  </a>
                </p>
                <p className="level-item has-text-weight-bold">
                  <a href="/blog/category/company" className="has-text-dark">
                    Company
                  </a>
                </p>
              </div>
            )}
            {isMobile && (
              <nav className="scrolling-mobile-menu mt-6 has-text-weight-bold">
                <a href="/blog">All Posts</a>
                <a href="/blog/category/features">Features</a>
                <a href="/blog/category/bikes-gear">Bikes & Gear</a>
                <a href="/blog/category/community">Community</a>
                <a href="/blog/category/company">Company</a>
              </nav>
            )}
          </nav>
        </Container>
      </div>
    )
  }
}

export default BlogMenu
